import { ICellRendererParams } from '@amzn/gft-ag-grid-enterprise';
import { KPI_NAME_INDENT_SPACES } from '@constants/page';
import InfoIcon from '@mui/icons-material/Info';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { isEmpty } from 'lodash';
import { CSSProperties, memo } from 'react';

const KpiNameCellRenderer = (params: ICellRendererParams) => {
  if (params.value) {
    let displayName = params.value as string;
    let hasNameOverride = false;
    let footnotesString = '';
    let indentLevel = 0;

    if (params.data?.rawDecklineData) {
      const { rawDecklineData } = params.data;

      if (!isEmpty(rawDecklineData.display_name)) {
        displayName = rawDecklineData.display_name;
        hasNameOverride = true;
      }

      indentLevel = (rawDecklineData.kpi_name_indent_level ?? 0) * KPI_NAME_INDENT_SPACES;

      if (rawDecklineData.footnotes && rawDecklineData.footnotes.length > 0) {
        footnotesString = rawDecklineData.footnotes.join(',');
      }
    }

    const mainContent = (
      <Box>
        {displayName}
        {footnotesString.length > 0 && <sup>{footnotesString}</sup>}
      </Box>
    );

    const displayNameOverrideIcon = (
      <Tooltip title='Display Name Overridden for this Deckline' arrow>
        <Box className='display-kpiName__icon'>
          <InfoIcon fontSize='small' />
        </Box>
      </Tooltip>
    );

    return (
      <Box className='display-kpiName' style={{ '--indent-level': indentLevel } as CSSProperties}>
        {hasNameOverride && (
          <Stack direction='row' spacing={1}>
            {mainContent}
            {displayNameOverrideIcon}
          </Stack>
        )}
        {!hasNameOverride && mainContent}
      </Box>
    );
  }

  return '';
};

export default memo(KpiNameCellRenderer);
